module.exports = "{{#if url}} <a href={{url}} class=popout-menu__txt title={{getTitle}}>{{name}}</a> {{else}} <span class=popout-menu__txt title={{getTitle}}>{{name}}</span> {{/if}}";


//////////////////
// WEBPACK FOOTER
// ../src/dropdown/templates/menuItem.hbs
// module id = 652
// module chunks = 0